import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";
import styles from "./CustomTable.module.scss";

const CustomTable = ({
  columns,
  data,
  isLoading = false,
  noDataMessage = "No data available",
  hideHeader = false,
  sx = {},
  className,
}) => {
  const tableContainerClassName = [styles.tableContainer, className]
    .filter(Boolean)
    .join(" ");

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      className={tableContainerClassName}
      sx={sx}
    >
      <Table>
        {!hideHeader && (
          <TableHead className={styles.tableHead}>
            <TableRow>
              {columns.map((col, index) => (
                <TableCell
                  key={index}
                  className={[styles.headerCell, col.headerClassName]
                    .filter(Boolean)
                    .join(" ")}
                  sx={col.headerSx}
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell
                colSpan={columns.length}
                align="center"
                className={styles.stateCell}
              >
                <CircularProgress size={32} />
              </TableCell>
            </TableRow>
          ) : !data || data.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={columns.length}
                align="center"
                className={`${styles.stateCell} ${styles.noDataCell}`}
              >
                {noDataMessage}
              </TableCell>
            </TableRow>
          ) : (
            data.map((row, rowIndex) => (
              <TableRow
                key={rowIndex}
                className={`${styles.dataRow} ${
                  hideHeader ? styles.transparentHover : ""
                }`}
              >
                {columns.map((col, colIndex) => (
                  <TableCell
                    key={colIndex}
                    className={[styles.bodyCell, col.cellClassName]
                      .filter(Boolean)
                      .join(" ")}
                    sx={col.cellSx}
                  >
                    {col.render ? col.render(row, rowIndex) : row[col.id]}
                  </TableCell>
                ))}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CustomTable;
